
import img0 from './Images/MacOS_Login_Items.png';
import img1 from './Images/MacOS_Finder_Extension.png';
import img2 from './Images/MacOS_Overlay_Icon.png';
import img3 from './Images/MacOS_Notifications.png';
import img4 from './Images/MacOS_Monitor_Temp_Files.png';
import img5 from './Images/MacOS_Monitor_TextEdit_Files.png';
  
const content = `# SecureFile Settings on MacOS

When the SecureFile software is installed and registered, the following settings will be enabled for OnData SecureFile on MacOS. The user experience may be impacted 
if such settings are turned off.  
a. Launch the \`OnData SecureFile\` application upon user login, and enable the \`OnData DataManager\` to run in the background so that it can automatically 
discover, classify, and protect sensitive files. These settings are enabled under \`System Settings\` -> \`General\` -> \`Login Items & Extensions\` (For MacOS 14.x, 
such settings are under \`System Settings\` -> \`General\` -> \`Login Items\`).  
  
![Login Items](${ img0 })  
  
b. Add OnData SecureFile menu items to the Finder context menu: \`Encrypt with OnData...\`, \`Decrypt with OnData...\`, and \`Open With Specified App\`. 
This setting is enabled under \`System Settings\` -> \`General\` -> \`Login Items & Extensions\` -> \`Extensions\` -> \`File Providers\` (For MacOS 14.x, 
such setting is under \`System Settings\` -> \`Privacy & Security\` -> \`Others\` -> \`Extensions\` -> \`File Providers\`).  
  
![Finder Extension](${ img1 })  
  
c. Display the OnData overlay icon on top of original file icon. This setting is enabled under \`System Settings\` -> \`General\` -> \`Login Items & Extensions\` 
-> \`Extensions\` -> \`Quick Look\` (For MacOS 14.x, such setting is under \`System Settings\` -> \`Privacy & Security\` -> \`Others\` -> \`Extensions\` -> \`Quick Look\`).  
  
![Overlay Icon](${ img2 })  
  
d. Enable notification from the OnData SecureFile application. This setting is enabled under \`System Settings\` -> \`Notifications\` -> \`OnData SecureFile\`.  
  
![Notifications](${ img3 })  
  
e. Enable OnData SecureFile to monitor the files opened or closed by other applications, so that OnData SecureFile can clean up the temporary files when they 
are not used anymore. This setting is enabled under \`Privacy & Security\` -> \`Automation\` -> \`OnData SecureFile\`.  
  
![Monitor Temporary Files](${ img4 })  
  
When you are prompted to choose whether allowing OnData SecureFile to control an application, please select the \`Allow\` option so that OnData SecureFile can 
monitor the files opened or closed by other applications. Below is an example on allowing OnData SecureFile to monitor the files opened or closed by the 
\`TextEdit.app\`.  
  
![Monitor TextEdit Files](${ img5 })  
  
  `
  
export default content;
